import { w as writable } from "./index2.js";
const callbacks = [];
const globalConfirm = writable({
  open: false,
  content: "Bist du sicher?",
  confirmed: false,
  confirm(content, callback = () => {
  }) {
    callbacks.push(callback);
    globalConfirm.update((modal) => {
      modal.content = content;
      modal.confirmed = false;
      modal.open = true;
      return modal;
    });
  },
  _() {
    globalConfirm.update((modal) => {
      modal.open = false;
      modal.confirmed = true;
      return modal;
    });
  }
}, () => {
  globalConfirm.update((modal) => {
    modal.open = false;
    modal.confirmed = false;
    return modal;
  });
  return () => {
    console.log("unsubscribed");
  };
});
globalConfirm.subscribe((modal) => {
  if (modal.confirmed && callbacks.length > 0) {
    callbacks[callbacks.length - 1]();
    callbacks.pop();
  }
});
export {
  globalConfirm as g
};
//# sourceMappingURL=modal.js.map
